export interface TaskVariable {
  name: string;
  value?: string;
}

export enum MessageActionType {
  ACCEPT = 'accept',
  AVAILABLE = 'available',
  NOT_AVAILABLE = 'not-available',
  REJECT = 'reject',
  SEEN = 'seen'
}

export type MessageAction = { [key in MessageActionType]: MessageActionType };

export interface EmployeeMessage {
  processInstanceId: string;
  executionId: string;
  taskDefinitionKey: string;
  createTime: Date;
  taskVariables: TaskVariable[];
  active: boolean;
  taskName: string;
  message: {
    subject: string;
    body: string;
  };
  reply: string;
  actions: MessageAction[];
  taskId: string;
}

export enum TaskDefinitionGroup {
  ALL = '',
  EMPLOYEE_DUTY_NOTIFICATIONS_TASK_KEYS = 'EMPLOYEE_DUTY_NOTIFICATIONS_TASK_KEYS',
  EMPLOYEE_DUTY_REQUESTS_TASK_KEYS = 'EMPLOYEE_DUTY_REQUESTS_TASK_KEYS',
  EMPLOYEE_INFORMATION_ITEM_TASK_KEYS = 'EMPLOYEE_INFORMATION_ITEM_TASK_KEYS',
  EMPLOYEE_LEAVE_REQUEST_TASK_KEYS = 'EMPLOYEE_LEAVE_REQUEST_TASK_KEYS'
}

export enum TaskDefinitionStatus {
  ALL = 'all',
  OPEN = 'open',
  HISTORY = 'history'
}

export type MessageForm = {
  type: {
    label: TaskDefinitionGroup;
    value: TaskDefinitionGroup;
  };
  status: {
    label: TaskDefinitionStatus;
    value: TaskDefinitionStatus;
  };
};
